import Hero from '../elements/Hero';
import { privacyPolicyDate, privacyPolicySections, privacyPolicyTitle } from '../data/privacyPolicy';

function PolicyText({ text }) {
  const parts = text.split(/(privacy@baling\.com)/g);

  return parts.map((part, index) => (
    part === 'privacy@baling.com'
      ? <a href="mailto:privacy@baling.com" key={`${part}-${index}`}>{part}</a>
      : part
  ));
}

function PolicyBlocks({ blocks }) {
  return (
    <>
      {blocks.map((block, index) => {
        const key = `${block.type}-${index}`;

        if (block.type === 'heading') {
          return <h3 key={key}>{block.text}</h3>;
        }

        if (block.type === 'list') {
          return (
            <ul key={key}>
              {block.items.map((item) => <li key={item}><PolicyText text={item} /></li>)}
            </ul>
          );
        }

        if (block.type === 'nested-list') {
          return (
            <ul key={key}>
              {block.items.map((item) => (
                <li key={item.text}>
                  <PolicyText text={item.text} />
                  <ul>
                    {item.items.map((child) => <li key={child}><PolicyText text={child} /></li>)}
                  </ul>
                </li>
              ))}
            </ul>
          );
        }

        return <p key={key}><PolicyText text={block.text} /></p>;
      })}
    </>
  );
}

function PrivacyPolicy() {
  return (
    <>
      <Hero
        eyebrow={privacyPolicyDate}
        title="Data Collection and Privacy Policy"
        description="How C&M Baling Systems collects, uses, stores, and protects information submitted through website forms."
        image="equipment/horizontal-balers/horizontal-8.jpg"
        compact
      />
      <main>
        <article className="privacy-policy article">
          <section className="content-block">
            <h2>{privacyPolicyTitle}</h2>
            <p><em>{privacyPolicyDate}</em></p>
          </section>

          {privacyPolicySections.map((section) => (
            <section className="content-block" key={section.id}>
              <h2>{section.title}</h2>
              <PolicyBlocks blocks={section.blocks} />
            </section>
          ))}
        </article>
      </main>
    </>
  );
}

export default PrivacyPolicy;
